import { ForwardedRef, forwardRef } from 'react';
import classNames from 'classnames';

import { ListMode } from '../../utils/types/stateful-list.types';
import { ItemListWrapper } from '../item-list-wrapper/item-list-wrapper';
import ListSearch from '../search/list-search';

import { SingleSelectContext } from './single-select.context';
import { SingleSelectInputProps } from './single-select.types';
import { useSingleState } from './use-single-state';

export const ListSingleSelectProvider = forwardRef(
  (props: SingleSelectInputProps, ref?: ForwardedRef<HTMLDivElement>) => {
    const value = useSingleState(props);
    const { useSearch, activeDescendantId, containerRef, onKeyDown } = value;

    return (
      <SingleSelectContext.Provider value={value}>
        <ItemListWrapper
          {...props}
          ref={ref}
          activeDescendantId={activeDescendantId}
          containerRef={containerRef}
          onKeyDown={onKeyDown}
          renderItems={value.renderItems}
          mode={ListMode.Single}
          className={classNames(props.className)}
        >
          {useSearch && (
            <ListSearch
              search={value.search}
              setSearch={value.setSearch}
              focusId={`focusable-item-search-input-${value.renderItems.id}`}
              activeDescendantId={activeDescendantId}
            />
          )}
        </ItemListWrapper>
      </SingleSelectContext.Provider>
    );
  }
);

export default ListSingleSelectProvider;
